import React, { useState } from 'react';
import loginVideo from '../assets/login_video.mp4'; // make sure the path is correct
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
const PrefillDataModal = ({ onClose }) => {
    const [selectedOption, setSelectedOption] = useState('');
    const navigate = useNavigate();
    const onsubmit = () => {
        if (!selectedOption) {
            toast.error('Please select an OTP option');
            return;
        }
        else if(selectedOption === 'efiling') {
            toast.success('OTP sent via E-filing website');
            navigate('/dual-otp-verification');
        } else if(selectedOption === 'aadhaar') {
            toast.success('OTP sent via Aadhaar');
            navigate('/final-otp');
        }
        toast.success(`OTP sent via ${selectedOption}`);
        
    }
    return (
        <div className="fixed inset-0 z-50 overflow-hidden">
            <ToastContainer />
            {/* Background Video */}
            <video
                autoPlay
                muted
                loop
                className="absolute inset-0 w-full h-full object-cover z-0"
            >
                <source src={loginVideo} type="video/mp4" />
                Your browser does not support the video tag.
            </video>

            {/* Overlay for dim effect */}
            <div className="absolute inset-0 bg-black bg-opacity-50 z-10" />

            {/* Modal with glass effect */}
            <div className="relative z-20 flex items-center justify-center min-h-screen px-4">
                <div className="backdrop-blur-lg bg-white/20 w-full max-w-2xl rounded-xl shadow-2xl border border-white/30">
                    {/* Header */}
                    <div className="flex items-center justify-between px-6 py-4 border-b border-white/30">
                        <h2 className="text-lg font-semibold text-white">Get Prefill Data</h2>
                        <button onClick={onClose} className="text-white text-xl hover:text-gray-200">
                            &times;
                        </button>
                    </div>

                    {/* Body */}
                    <div className="px-6 py-6 space-y-6 text-white">
                        <div>
                            <label className="block font-medium mb-2">
                                OTP <span className="text-sm text-white/70">(For Get Prefill Data)</span>
                            </label>
                            <div className="flex flex-wrap gap-6 items-center">
                                <label className="flex items-center gap-2">
                                    <input
                                        type="radio"
                                        name="otpOption"
                                        value="efiling"
                                        checked={selectedOption === 'efiling'}
                                        onChange={(e) => setSelectedOption(e.target.value)}
                                        className="accent-cyan-300 w-4 h-4"
                                    />
                                    <span>E-filing Website</span>
                                </label>

                                <label className="flex items-center gap-2">
                                    <input
                                        type="radio"
                                        name="otpOption"
                                        value="aadhaar"
                                        checked={selectedOption === 'aadhaar'}
                                        onChange={(e) => setSelectedOption(e.target.value)}
                                        className="accent-cyan-300 w-4 h-4"
                                    />
                                    <span>Aadhaar</span>
                                </label>

                                <button
                                    className="ml-auto px-6 py-2 bg-cyan-500 text-white rounded-lg hover:bg-cyan-600 transition"
                                    // disabled={!selectedOption}
                                    onClick={onsubmit}
                                >
                                    Send OTP
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* Footer */}
                    <div className="px-6 py-4 text-right border-t border-white/30">
                        <button
                            onClick={() => navigate('/dashboard')}

                            className="px-5 py-2 bg-cyan-500 text-white rounded-lg hover:bg-cyan-600 transition"
                        >
                            Skip OTP
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PrefillDataModal;
